export default __webpack_public_path__ + "static/media/illustration-recruit-3-m@3x.1f5bc3e1.webp";